import type { FetchiosError } from "@caprikorn/dynamo-utils";

import { CUSTOM_ERRORS } from "@services/apiEcms/apiEcms.constants";
import type { ApiErrorLegacy, FormattedError } from "@services/services.types";

export const formatCaughtError = (error: unknown): FormattedError => {
  if ((error as FetchiosError<ApiErrorLegacy>).response) {
    return {
      data: {
        type:
          (error as FetchiosError<ApiErrorLegacy>).response?.data?.type ?? "",
        message:
          (error as FetchiosError<ApiErrorLegacy>).response?.data?.message ??
          "",
        details:
          (error as FetchiosError<ApiErrorLegacy>).response?.data?.details ??
          "",
      },
      status:
        (error as FetchiosError<ApiErrorLegacy>).response?.status ||
        CUSTOM_ERRORS.UNSPECIFIED_ERROR.status,
    };
  }

  if (
    error instanceof Error ||
    ((error as Error).name && (error as Error).message)
  ) {
    return {
      data: {
        type: (error as Error).name,
        message: (error as Error).message,
        details: (error as Error).stack ?? "",
      },
      status: CUSTOM_ERRORS.UNSPECIFIED_ERROR.status,
    };
  }

  return {
    data: {
      type: CUSTOM_ERRORS.UNSPECIFIED_ERROR.type,
      message: CUSTOM_ERRORS.UNSPECIFIED_ERROR.message,
      details: "",
    },
    status: CUSTOM_ERRORS.UNSPECIFIED_ERROR.status,
  };
};
